import BaseClient from './BaseClient';

export default class InterestServiceClient extends BaseClient {
  constructor(billingDate = null, tenantId: string) {
    super(billingDate, tenantId, true, "ams");
  }

  public async getInterestSet(interestSetId) {
    const response = await this.get(`/api/proxy/ams/interest-service/interest-set/${interestSetId}`);
    return await this.handleResponse<any>(response);
  }

  public async getAccountInterestRates(accountId: string) {
    const response = await this.get(`/api/proxy/ams/interest-service/account/${accountId}/rates`);
    return await this.handleResponse<any>(response);
  }

  public async getAccountEffectiveRates(accountId: string) {
    const response = await this.get(`/api/proxy/ams/interest-service/account/${accountId}/effective-rates`);
    return await this.handleResponse<any>(response);
  }

  public async getAccountRateHistory(accountId: string) {
    const response = await this.get(`/api/proxy/ams/interest-service/account/${accountId}/rate-history`);
    return await this.handleResponse<any>(response);
  }

  public async getBillingPeriodEstimatedInterest(accountId: string, billingPeriodId: number) {
    let response = await this.get(
      `/api/proxy/ams/interest-service/account/${accountId}/estimated-interest/${billingPeriodId}`
    );
    return await this.handleResponse<any>(response);
  }

  public async reverseTransaction(accountId: string, transactionId: string, description: string) {
    let body = {
      description,
    };
    const response = await this.post(
      `/api/proxy/ams/interest-service/account/${accountId}/interest-transaction/${transactionId}/reverse`,
      body
    );
    return await this.handleResponse(response);
  }

  public async createInterestTransaction(accountId: string, amount: number, description: string, subledgerId: string) {
    let body = {
      description,
      allocations: [
        {
          subledgerId,
          amount: {
            value: amount,
            currencyCode: 'GBP',
          },
        },
      ],
    };
    const response = await this.post(`/api/proxy/ams/interest-service/account/${accountId}/interest-transaction`, body);
    return await this.handleResponse(response);
  }

  public async getAccruedInterestForBillingPeriod(accountId: string) {
    const response = await this.get(`/api/proxy/ams/interest-service/account/${accountId}/accrued-interest`);
    return await this.handleResponse<any>(response);
  }

  public async getInterestAssessmentForBillingPeriod(accountId: string, billingPeriodId: number) {
    const response = await this.get(
      `/api/proxy/ams/interest-service/account/${accountId}/interest-assessment?billingPeriodId=${billingPeriodId}`
    );
    return await this.handleResponse<any>(response);
  }
}

export const useInterestService = (billingDate = null, tenantId: string): InterestServiceClient => {
  return new InterestServiceClient(billingDate, tenantId);
};
